// extracted by mini-css-extract-plugin
module.exports = {"container":"useNotification_container__OU03r"};